<script lang="ts">
    import {pipe} from 'core/utils';
    import {exists} from 'shared/utils/custom-utils';
    import {characters} from 'shared/utils/pipes';

    export let title: string;
    export let subtitle: string | undefined;
</script>

<h1 class="kp-search-header-title">
    <span class="search-header">{pipe(title, characters(200))}</span>
    {#if exists(subtitle)}
        <small class="search-subheader">{pipe(subtitle, characters(200))}</small>
    {/if}
</h1>

<style lang="less">
    .kp-search-header-title {
        margin-top: 0;
    }
</style>